const COMMENTS = [
  {
    name: '电影爱好者小陈',
    text: '97影视真的太棒了！片源更新速度超快，昨天刚上映的动作大片今天就能看了，画质还特别清晰，强烈推荐给所有喜欢看电影的朋友。',
    rating: 5,
    tag: '动作片爱好者',
  },
  {
    name: '追剧达人Linda',
    text: '试过很多免费电影网站，97影视是体验最好的一个。最大的亮点是播放流畅不缓冲，晚上高峰期看高清电影也完全不卡，比某些收费平台还稳定。',
    rating: 5,
    tag: '喜剧片粉丝',
  },
  {
    name: '周末影迷老张',
    text: '分类很全，从经典老片到最新上映的动作片、喜剧片都能找到。界面简洁干净，没有乱七八糟的弹窗广告，观影体验非常纯净。',
    rating: 4,
    tag: '老电影爱好者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            观众热评
          </h2>
          <p className="text-sm text-foreground-500 mt-2">看看影迷们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 border border-background-200/60 rounded-lg p-5"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < comment.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-400'}`}
                  />
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                    <span className="text-xs font-semibold text-primary-500">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <span className="text-sm font-medium text-foreground-700">{comment.name}</span>
                </div>
                <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-1 rounded">
                  {comment.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}